import { Box, MenuItem, Tooltip } from '@mui/material';
import OutlinedInput from '@mui/material/OutlinedInput';
import { UPDropdownLabelContainer, UPInputLabel } from 'components/input/styles';
import React from 'react';
import theme from 'theme';
import { ReactComponent as CloseIcon } from '../../assets/icons/Close.svg';
import { CompanyNameInputStyled, DropdownPlaceholder, MenuProps, UPDropdownHelperText, UPSelectStyled } from './styles';
import { UPDropdownProps } from './types';
import { ReactComponent as InfoIcon } from '../../assets/icons/InfoIcon.svg';

const UPDropdown = React.forwardRef((props: UPDropdownProps, ref): JSX.Element => {
  const {
    items,
    value,
    onChange,
    placeholder,
    label,
    className,
    required,
    error,
    helperText,
    disabled,
    isFilter,
    disableUnderline,
    gtmEvent,
    id,
    labelTooltip,
    testId,
  } = props;

  const onClearSelection = () => {
    onChange({
      target: {
        value: '',
      },
    });
  };

  return (
    <Box className={className} sx={{ width: '100%' }}>
      <UPDropdownLabelContainer>
        <UPInputLabel>
          {label} {required && '*'}
        </UPInputLabel>
        {labelTooltip && (
          <Tooltip title={labelTooltip} placement="top" arrow>
            <InfoIcon width={12} height={12} />
          </Tooltip>
        )}
      </UPDropdownLabelContainer>

      <UPSelectStyled
        displayEmpty
        value={value}
        onChange={onChange}
        input={disableUnderline ? <CompanyNameInputStyled /> : <OutlinedInput />}
        renderValue={value === '' ? () => <DropdownPlaceholder>{placeholder}</DropdownPlaceholder> : undefined}
        MenuProps={MenuProps}
        fullWidth
        ref={ref}
        required
        error={error}
        disabled={disabled}
        disableUnderline={disableUnderline}
        endAdornment={
          value !== '' &&
          isFilter &&
          !disabled && (
            <Box onClick={() => onClearSelection()} sx={{ mr: theme.spacing(2), cursor: 'pointer', height: '24px' }}>
              <CloseIcon fill={theme.palette.primary.main} />
            </Box>
          )
        }
        id={id}
        SelectDisplayProps={{ 'data-testid': testId } as React.HTMLAttributes<HTMLDivElement>}
      >
        {/* {isFilter && (
          <MenuItem value="">
            <div>{t(CONTRACTS__NONE)}</div>
          </MenuItem>
        )} */}
        {items.map(item => (
          <MenuItem
            key={item?.value}
            value={item?.value}
            disabled={item?.isDisabled}
            data-gtm-event={gtmEvent}
            data-testid={item?.testId}
          >
            {item?.label}
          </MenuItem>
        ))}
      </UPSelectStyled>
      {/* Only render the helper line when there is something to say — an errored dropdown with no message
          would otherwise reserve a blank line and shift the layout around it. */}
      {error && helperText && <UPDropdownHelperText>{helperText}</UPDropdownHelperText>}
    </Box>
  );
});

UPDropdown.defaultProps = {
  placeholder: 'Select',
  className: '',
  required: false,
  error: false,
  helperText: '',
  disabled: false,
};
export default UPDropdown;
